module.exports = __webpack_public_path__ + "img/group.2524a7e3.png";